/**
 * Packers session: mute customer Order Packed / Order Shipped emails.
 * sessionStorage only — lasts for the browser tab / pack session, not forever.
 * Default: **muted** (emails off) until staff uncheck Quick Bar → Mute packed / shipped emails.
 * Pack / ship Firestore writes are unaffected.
 */

export const MUTE_PACKERS_CUSTOMER_PACK_EMAILS_SESSION_KEY =
  'lsc_packers_mute_customer_pack_emails_v1';

export function readMutePackersCustomerPackEmails() {
  try {
    const raw = sessionStorage.getItem(MUTE_PACKERS_CUSTOMER_PACK_EMAILS_SESSION_KEY);
    if (raw === null) return true;
    return raw === '1';
  } catch {
    return true;
  }
}

export function writeMutePackersCustomerPackEmails(muted) {
  const value = Boolean(muted);
  try {
    sessionStorage.setItem(
      MUTE_PACKERS_CUSTOMER_PACK_EMAILS_SESSION_KEY,
      value ? '1' : '0'
    );
  } catch {
    /* ignore quota / private mode */
  }
  return value;
}

/** Used by emailtransporter senders — true means do not send. */
export function isPackersCustomerPackEmailsMuted() {
  return readMutePackersCustomerPackEmails();
}
